<mat-card class="w-full" appearance="outlined">
  <img mat-card-image src="{{video.thumbnail}}" alt="Thumbnail of playlist">
  <mat-card-content>
  </mat-card-content>
  <mat-card-footer class="p-2">
    <mat-card-title>
      <b>{{ video.title }}</b>
    </mat-card-title>
    <mat-card-subtitle>
      <p class="text-sm" >{{ video.id }}</p>
    </mat-card-subtitle>
    <p>{{ video.channel.title }} ({{ video.channel.id }})</p>
  </mat-card-footer>
</mat-card>